// Deep import: the aos-ds barrel runs createModal/createButton/cssInterop at
// module scope, so importing it here would execute all of that at app startup.
import { Spinner as DesignSystemSpinner } from 'aos-ds/src/primitives/spinner/Spinner'
import { CenteredBox } from 'aos-ui/src/components/base/Box'
import React, { FC } from 'react'

interface SpinnerProps {
    inContent?: boolean
}

export const Spinner: FC<SpinnerProps> = ({ inContent }) => (
    <CenteredBox absolute={!inContent}>
        <DesignSystemSpinner />
    </CenteredBox>
)
